import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { TableCreditRecoveryValues } from "../TableCreditRecoveryValues";

interface Props {
	open: boolean;
	sinisterId: string;
	onClose: () => void;
}

export const ModalSinisterValues = ({ open, sinisterId, onClose }: Props) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
			<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<Typography variant="h6" color="primary" sx={{ fontWeight: 400 }}>
					Valores do Sinistro
				</Typography>
				<IconButton onClick={onClose} size="small">
					<CloseIcon fontSize="small" />
				</IconButton>
			</DialogTitle>

			<DialogContent dividers sx={{ bgcolor: "background.paper" }}>
				<TableCreditRecoveryValues sinisterId={sinisterId} />
			</DialogContent>
		</Dialog>
	);
};
